import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'convfact-admintabs',
    templateUrl: './admin-tabs.component.html',
    styleUrls: ['./admin-tabs.component.scss'],
    standalone: false
})
export class AdminTabsComponent implements OnInit {
  routes: object[];

  constructor(
    private router: Router,
  ) {
    this.routes = [
      { label: 'Usuarios', link: '/admin/users', enable: true },
      { label: 'Partners', link: '/admin/advisors', enable: true },
      { label: 'Ayuda', link: '/admin/help', enable: true },
      { label: 'Log', link: '/admin/log', enable: true },
      { label: 'Eventos', link: '/admin/event', enable: true },
      { label: 'Contactos', link: '/admin/contacts', enable: true },
      { label: 'Verifactu', link: '/admin/verifactu', enable: true },
    ];
  }

  ngOnInit() {
  }
}
